<!--  -->
<template>
  <div>
    <div>
      <div class="serch_box search_box">
        <el-input v-model="query.keywords" clearable style="width:300px;margin-right:10px" placeholder="请输入员工编号/名称" />
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <!-- <el-table-column
        prop="id"
        label="id"
        align="center"
        width="100"
      /> -->
      <el-table-column
        prop="name"
        label="员工名字"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工编号(企业名称)"
        align="center"
        width="500"
      >
        <template slot-scope="scope">
          <div>
            <div class="sdwr">
              <el-tooltip class="item" effect="dark" :content="scope.row.relation_id" placement="top">
                <div class="gecawe" style="width: 480px;"> {{ scope.row.relation_id }}({{ scope.row.corp_name }})</div>）
              </el-tooltip>
            </div>
            <!-- {{ scope.row.relation_id }}（{{ scope.row.corp_name }}） -->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="标签组"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <div class="tag-clamp">
            <el-tag v-for="item in (scope.row.tags || [])" :key="item">{{ item }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.status == 2" class="el-icon-success defaultr" />
          <i v-if="scope.row.status == 3" class="el-icon-error stopew" />
          <i v-if="scope.row.status == 4" class="el-icon-error fasrw" />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="发送结果"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.send_status_text }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="400"
      >
        <template slot-scope="scope">
          <div>
            <div class="sdwr">
              <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top">
                <div class="gecawe" style="width: 380px;"> {{ scope.row.remark }}</div>）
              </el-tooltip>
            </div>
            <!-- {{ scope.row.relation_id }}（{{ scope.row.corp_name }}） -->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-button type="primary" size="mini" @click="unbind">解绑</el-button>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { momentsPushbindList, momentsPushunBinding } from '@/api/officialaccount.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        page_size: 10,
        keywords: null,
        sp_push_no: null
      },
      selectlist: [],
      selectlistsend: [],
      group_selection: null,
      dialogVisiblepush: false,
      namearr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    rowKey(row) {
      return row.id
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.send_time_passed != false // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    async list() {
      this.loading = true
      const data = await momentsPushbindList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.list()
    },
    send(sp_push_no) {
      this.query.sp_push_no = sp_push_no
      this.list()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    unbind() {
      console.log(this.selectlist)
      if (this.selectlist.length === 0) {
        this.$message.error('请选择需要解绑的人员')
        return
      }
      this.namearr = []
      this.namearr = this.selectlist.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
        return itemr.name
      })
      this.$confirm(`确定解绑 ${this.namearr.join(',')} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.selectlistsend = []
        this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
          // eslint-disable-next-line eqeqeq
          return itemr.relation_id
        })

        momentsPushunBinding({
          sp_push_no: this.query.sp_push_no,
          relation_ids: this.selectlistsend
        }).then((res) => {
          // this.$emit('updata')
          this.list()
          this.$message({
            message: '解绑成功',
            type: 'success'
          })
          this.selectlist = []
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serch_box{
  margin-bottom: 10px;
}
.sdwr{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gecawe{
  display: inline-block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.tag-clamp{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 超过两行省略 */
  line-clamp: 2;
  overflow: hidden;
  white-space: normal;
}
</style>
